import ImageShow from './imageShow/ImageShow';
import ModelAccessories from './modelAccessories/ModelAccessories';
import ModelDescriptions from './modelDescriptions/ModelDescriptions';
import ModelInfo from './modelInformation/ModelInfo';
import ModelParameters from './modelParameters/ModelParameters';
import { IModelOpinion, IProductModel } from './dataModels/ProductModels';
import { ProductService } from '../../services/productService/ProductService';
import * as style from './style.css';
import { IEditProps } from '../../framework/framework/edit/EditComponent';
import { IBreadcrumb } from '../../framework/framework/shared/models/IBreadcrumb';
import { IEditViewModel } from '../../framework/framework/edit/IEditViewModel';
import Breadcrumbs from '../../framework/framework/components/Breadcrumbs';
import classes from '../../framework/framework/tools/classes';
import ModelFiles from './modelFiles/ModelFiles';
import { Helmet } from 'react-helmet';
import ModelOpinions from './opinions/ModelOpinions';
import ActionButton from '../../components/actionButton/ActionButton';
import ScrollUpButton from '../../components/scrollUpButton/ScrollUpButton';
import ContextMenu from '../../components/contextMenu/ContextMenu';
import ProductContextMenu from './productContextMenu/ProductContextMenu';
import React = require('react');
import cookie = require('cookie');

interface IProps extends IEditProps {
    productName: string;
}

interface IState {
    editModel: IProductModel;
    layout: boolean;
    indexUrl: string;
    messages: string[];
    breadcrumbs: IBreadcrumb[];
    showModal: boolean;
    infoOpen: string;
    modalContent: React.ReactElement;
    reviewOpen: boolean;
    isContextMenuVisible: boolean;
}

export default class ProductCard extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            editModel: null,
            layout: false,
            indexUrl: null,
            messages: [],
            breadcrumbs: [],
            showModal: false,
            modalContent: null,
            infoOpen: '',
            reviewOpen: false,
            isContextMenuVisible: false
        };
    }

    productService = ProductService.Instance();

    componentDidMount() {
        const url = this.props.appCtx.buildUrl(`${this.props.controller}/ProductData/${this.props.productName}`);
        this.productService.getProductData(url, data => this.onEditDataChanged(data));
        window.addEventListener('resize', this.windowResize);
        window.addEventListener('scroll', this.windowScroll);
    }

    windowScroll() {
        let elem = document.getElementById('scrollUpButton');
        elem.style.display = window.pageYOffset > 100 ? 'block' : 'none';

        elem = document.getElementById('productContextMenu');
        elem.style.display = window.pageYOffset > 100 ? 'block' : 'none';
    }

    windowResize() {
        const margin = window.getComputedStyle(document.getElementById('cardWrapper')).marginLeft;
        document.documentElement.style.setProperty('--margin', margin);
    }

    setCookie(id: number) {
        const cookies = cookie.parse(document.cookie);
        const reviewed = cookies.reviewed || '[]';

        let ids = JSON.parse(reviewed) || [];
        ids = ids.filter(x => x !== id);
        ids.push(id);

        document.cookie = cookie.serialize('reviewed', JSON.stringify(ids), { path: '/', maxAge: 60 * 60 * 24 * 365 });
    }

    onEditDataChanged(data: any) {
        const vm = data as IEditViewModel;
        this.setCookie(vm.editModel.id);
        this.fillEditModel(vm.editModel as IProductModel);

        this.setState({
            editModel: vm.editModel as IProductModel,
            breadcrumbs: vm.breadcrumbs
        }, () => {
            this.scrollToHash();
        });
    }

    fillEditModel(editModel: IProductModel) {
        if (editModel.images.length === 0) { editModel.images.push({ id: 1, thumbnail: this.props.appCtx.buildAssetsUrl('assets/camera.svg') }); }
    }

    scrollToHash() {
        const hash = window.location.hash.substring(1);
        if (hash && hash.length > 0) {
            const element = document.getElementById(hash);
            window.requestAnimationFrame(() => {
                element.scrollIntoView();
            });
        }
        this.windowResize();
    }

    render() {
        const model = this.state.editModel;
        return (
            <div id={'cardWrapper'} className={style.productCardWrapper}>
                {model && <Helmet>
                    <title>{'apcprodent.pl - ' + model.generalInfo.name}</title>
                    <meta name="description" content={`${model.seoModel.metaDescription}`} />
                    <script type="application/ld+json" >
                        {model.seoModel.breadcrumbs}
                    </script>
                    <script type="application/ld+json" >
                        {model.seoModel.jsonLd}
                    </script>
                </Helmet>}
                {model && this.state.infoOpen === 'supplier' &&
                <div className={style.infoSidePanel}>
                    left side panel
                </div>
                }
                {model && <ContextMenu >
                    <ProductContextMenu
                        info={this.state.editModel.generalInfo}
                        basketAction={() => this.productService.addToBasket(model.id, model.generalInfo.name, 1)}
                    />

                </ContextMenu>
                }
                <Breadcrumbs breadcrumbs={this.state.breadcrumbs} />
                <ScrollUpButton />
                <div className={style.productCard}>
                    <div className={classes(style.header)}>

                        {model &&
                        <div className={style.images}>
                            <ImageShow images={model.images} />
                        </div>
                        }
                        {model &&
                        <div className={style.info}>
                            <ModelInfo
                                productId={this.state.editModel.id}
                                thumbnail={model.images[0].thumbnail}
                                productService={this.productService}
                                info={model.generalInfo}
                                parameters={model.parameters}
                                parcels={model.parcels}
                                uriBuild={(path: string) => this.props.appCtx.buildUrl(path)}

                            />
                        </div>
                        }
                    </div>
                    {/* <div id={'links'} className={classes(style.section, style.links)}>
                    <div className={style.linksBar}>
                        <ul>
                            <li><a href="#"><NorthIcon /></a></li>
                            <li><a href="#opis">Opis</a></li>
                            <li><a href="#parametry">  Parametry</a></li>
                            <li><a href="#akcesoria"> Akcesoria</a></li>
                            <li><a href="#opinie">Opinie</a></li>
                            <li><a href="#pliki">Pliki</a></li>
                        </ul>
                    </div>
                </div> */}

                    {model &&
                    <>
                        <a id="opis" className={style.sectionAnchor}></a>
                        <div className={classes(style.section, style.descriptions)}>
                            <h2 >Opis</h2>
                            <div className={style.bar}></div>
                            <ModelDescriptions
                                descriptions={model.descriptions}
                                uriBuild={(path: string) => this.props.appCtx.buildUrl(path)}
                            />

                        </div>
                    </>
                    }
                    {model && model.parameters.length > 0 &&
                    <>
                        <a id="parametry" className={style.sectionAnchor}></a>
                        <div className={classes(style.section, style.parameters)}>
                            <h2 >Parametry</h2>
                            <div className={style.bar}></div>
                            <ModelParameters parameters={model.parameters} />

                        </div>
                    </>
                    }
                    {model && model.files.length > 0 &&
                    <>
                        <a id="pliki" className={style.sectionAnchor}></a>
                        <div className={classes(style.section, style.parameters)}>
                            <h2 >Pliki</h2>
                            <div className={style.bar}></div>
                            <ModelFiles files={model.files} />
                        </div>
                    </>
                    }
                    {model && model.relatives.length > 0 &&
                    <>
                        <ModelAccessories
                            models={model.relatives}
                            uriBuild={(path: string) => this.props.appCtx.buildUrl(path)}
                        />

                    </>
                    }
                    {model &&
                    <>
                        <a id="opinie" className={style.sectionAnchor}></a>
                        <div className={classes(style.section, style.notes)}>
                            <h2>Opinie</h2>
                            <div className={style.bar}></div>
                            <div className={style.reviewHeader}>
                                <div className={style.reviewWrapper}>

                                    {!this.state.reviewOpen &&
                                    <ActionButton
                                        label="Dodaj opinię"
                                        onClick={() => this.onAddReviewClick()}
                                    >
                                    </ActionButton>
                                    }
                                </div>
                            </div>
                            <ModelOpinions
                                opinions={model.opinions}
                                appCtx={this.props.appCtx}
                                reviewFormOpen={this.state.reviewOpen}
                                onAddReview={r => this.onAddReview(r)}
                            />
                        </div>
                    </>
                    }
                </div>
            </div>);
    }

    onAddReview(r: IModelOpinion): void {
        r.productId = this.state.editModel.id;
        this.productService.addReview(r).then(() => {
            this.setState({ reviewOpen: false });
        }).catch(() => {
            this.setState({ reviewOpen: false });
        });
    }

    onAddReviewClick(): void {
        this.setState({ reviewOpen: true });
    }
}
